module.exports = __webpack_public_path__ + "static/novo-cream-rolls2-fb2b9588cb582f44dc3856db4c8ea391.jpg";